import { useQuery } from '@apollo/client/react';
import { Helmet } from 'react-helmet';

import { OrganisationDocument } from 'graphql/types';

interface IProps {
    children: string;
}

export const PageTitle = ({ children: title }: IProps) => {
    const { data: organisationData } = useQuery(OrganisationDocument);

    if (!title) return null;

    const { name: orgName } = organisationData?.organisation || {};

    return (
        <Helmet>
            <title>
                {title}
                {orgName ? ` - ${orgName}` : ''}
            </title>
        </Helmet>
    );
};
